export default "__VITE_ASSET__0947a7ef__"